"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.alignmentOptions = exports.fontSizeOptions = exports.blockHeightOptions = exports.blockSpacingOptions = exports.blockWidthOptions = void 0;
var react_1 = __importDefault(require("react"));
var icons_1 = require("@qwilr/kaleidoscope/icons");
var commonTypes_1 = require("./commonTypes");
var SMALL = "small";
var MEDIUM = "medium";
var LARGE = "large";
var NONE = "none";
exports.blockWidthOptions = [
    {
        label: "S",
        value: SMALL,
    },
    {
        label: "M",
        value: MEDIUM,
    },
    {
        label: "L",
        value: LARGE,
    },
    {
        label: "Custom",
        value: "custom",
    },
];
exports.blockSpacingOptions = [
    {
        label: "S",
        value: SMALL,
    },
    {
        label: "M",
        value: MEDIUM,
    },
    {
        label: "L",
        value: LARGE,
    },
    {
        label: "Custom",
        value: "custom",
    },
];
exports.blockHeightOptions = [
    {
        label: "None",
        value: NONE,
    },
    {
        label: "1/3",
        value: SMALL,
    },
    {
        label: "1/2",
        value: MEDIUM,
    },
    {
        label: "Full",
        value: LARGE,
    },
];
exports.fontSizeOptions = [
    {
        label: "S",
        value: commonTypes_1.OptionLabelTypes.Small,
    },
    {
        label: "M",
        value: commonTypes_1.OptionLabelTypes.Medium,
    },
    {
        label: "L",
        value: commonTypes_1.OptionLabelTypes.Large,
    },
];
exports.alignmentOptions = [
    {
        label: "Left",
        value: commonTypes_1.AlignmentTypes.Left,
        icon: react_1.default.createElement(icons_1.AlignLeft, null),
    },
    {
        label: "Center",
        value: commonTypes_1.AlignmentTypes.Center,
        icon: react_1.default.createElement(icons_1.AlignCenter, null),
    },
];
